import { useConfig } from "@/contexts/cdpConfig";
import { useAdsContext } from "../context";
export const useShowAds = () => {
    const { loadedSlots } = useAdsContext();
    const isPreviewMode = useConfig().previewMode;
    /** true if one or more slot is not failed
     * this function is use to display section with slots
     * loaded slot is loading and is refreshed by the slotRenderEnded gpt event,
     * get failed , loading or loaded value
     * @param slotIds
     * @returns boolean
     */
    const isOneSlotNotFailed = (slotIds) => slotIds.some((slotId) => loadedSlots[slotId] && loadedSlots[slotId] !== "failed");
    /** true if all slots are loaded
     * loaded slot is loading and is refreshed by the slotRenderEnded gpt event,
     * !! WARNING do not use this function to display section with slots, only slot itself !!
     * @param slotIds
     * @returns boolean
     */
    const isAllSlotsLoaded = (slotIds) => slotIds.every((slotId) => loadedSlots[slotId] === "loaded");
    /**
     * this function is use to display section with slots
     * use isOneSlotNotFailed to check if one or more slot is not failed
     * use isPreviewMode to check if the preview mode is active
     * @param slotIds
     * @returns
     */
    const showSection = (slotIds) => {
        const slotdisplay = isOneSlotNotFailed(slotIds);
        return !isPreviewMode && slotdisplay;
    };
    return {
        showSection,
        isOneSlotNotFailed,
        isAllSlotsLoaded,
    };
};
